import { AutocompleteItem } from '@delmonicos/shared-design-system-react/src/components/autocomplete-input/autocomplete-input.component';
import { useEffect, useState } from 'react';

import { useCpmsBoGetCustomersPaginatedQuery } from '@service/cpms-bo-customer.service';

export const useCustomerAutocomplete = (
  selectedCustomerId: string | undefined,
): {
  search: string;
  setSearch: (search: string) => void;
  selectedItem: AutocompleteItem | null;
  autocompleteItems: AutocompleteItem[];
} => {
  const [search, setSearch] = useState<string>('');

  const { data, isSuccess } = useCpmsBoGetCustomersPaginatedQuery({
    offset: 0,
    limit: 100,
    name: search === '' ? undefined : `~${search}`,
  });

  const [selectedItem, setSelectedItem] = useState<AutocompleteItem | null>(
    null,
  );

  useEffect(() => {
    if (isSuccess) {
      const customer =
        data.docs.find(({ id }) => id === selectedCustomerId) ?? null;

      if (customer) {
        setSelectedItem({ key: customer.id, label: customer.name });
        return;
      }

      setSelectedItem(null);
    }
  }, [search, data, isSuccess, selectedCustomerId]);

  const [autocompleteItems, setAutocompleteItems] = useState<
    AutocompleteItem[]
  >([]);

  useEffect(() => {
    if (isSuccess) {
      setAutocompleteItems(
        data.docs.map(({ id, name }) => ({ key: id, label: name })),
      );
    }
  }, [search, data, isSuccess]);

  return { search, setSearch, selectedItem, autocompleteItems };
};
